module.exports = __webpack_public_path__ + "7dca4d4030038e52d6c3b12f7f85ad93.pdf";